<template>
	<section class="mysection">
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.username" placeholder="查询账号"></el-input>
				</el-form-item>
				<el-button type="primary" icon="el-icon-search">搜索</el-button>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table stripe :data="datalist" highlight-current-row v-loading="listLoading" height="450" style="width:90%;">
			<el-table-column label="操作" width="100" fixed>
				<template slot-scope="scope">
					<el-row>
						<el-button type="primary" icon="el-icon-edit" circle size="mini" @click="handleEdit(scope.$index, scope.row)"></el-button>
						<el-button type="danger" icon="el-icon-delete" circle size="mini" @click="handleDel(scope.$index, scope.row)"></el-button>
					</el-row>
				</template>
			</el-table-column>
			<el-table-column type="index" label="编号" width="60">
			</el-table-column>
			<el-table-column prop="username" label="账号" width="120">
			</el-table-column>
			<el-table-column prop="password" label="密码" width="120">
			</el-table-column>
			<el-table-column prop="name" label="姓名" width="120" >
			</el-table-column>
			<el-table-column prop="role" label="权限" width="100" :formatter="formatRoles">
			</el-table-column>
			<el-table-column prop="valid" label="状态" width="100" :formatter="formatValid">
			</el-table-column>
			<el-table-column prop="type" label="类型" width="350">
				<template scope="scope">
					{{formatType(scope.row)}}
				</template>
			</el-table-column>
		</el-table>
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="pagesize" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		<!--编辑界面-->
		<el-drawer
		  :title="editformtitle"
		  :visible.sync="editFormVisible" :before-close="clickClose"
		  size="40%" :with-header="false"
		  direction="rtl">
			<el-form :model="editForm" label-width="80px" :rules="formRules" ref="editForm">
				<el-container style="min-height: 100vh;">
					<el-header style="position: fixed; top: 0; width: 100%; z-index: 1024;">
					  <!-- 头部内容 -->
					  <div>
						<el-button @click.native="editFormVisible = false">取消</el-button>
						<el-button type="primary" @click.native="editSubmit" :loading="editLoading">保存</el-button>
					  </div>
					</el-header>
					<el-main>
						<el-card class="box-card">
						  <div slot="header" class="clearfix"><span>{{editformtitle}}</span></div>
						  <div class="text item">
							<el-form-item label="姓名" prop="name" class="is-required">
								<el-input v-model="editForm.name" auto-complete="off"></el-input>
							</el-form-item>
							<el-form-item label="账号" prop="username" class="is-required">
								<el-input v-model="editForm.username" auto-complete="off"></el-input>
							</el-form-item>
							<el-form-item label="企业" prop="cpcode" class="is-required">
								<el-select 
									v-model="editForm.cpcode" filterable placeholder="请输入/请选择" class="h-m-select">
								  <el-option v-for="item in company_options"
									:key="item.code" :label="item.name" v-model="item.code">
								  </el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="密码" prop="password" class="is-required">
								<el-input v-model="editForm.password" auto-complete="off"></el-input>
							</el-form-item>
							<el-form-item label="权限" prop="role" class="is-required">
								<el-select 
									v-model="editForm.role" filterable placeholder="请输入/请选择" class="h-m-select">
								  <el-option v-for="item in role_options"
									:key="item.value" :label="item.label" v-model="item.value">
								  </el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="用户类型" class="is-required">
								<el-select v-model="editForm.type" placeholder="请选择用户类型">
									<el-option label="系统用户" value="1"></el-option>
									<el-option label="业务员" value="2"></el-option>
									<el-option label="企业用户" value="3"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="状态" class="is-required">
								<el-select v-model="editForm.valid" placeholder="请选择状态">
									<el-option label="有效" value="1"></el-option>
									<el-option label="无效" value="0"></el-option>
								</el-select>
							</el-form-item>
						  </div>
						</el-card>		
					</el-main>
				</el-container>
				
				
			</el-form>
		</el-drawer>
	</section>
</template>

<script>
	import util from '../../common/js/util'
	//import NProgress from 'nprogress'
	import { getListPage, delData, saveData } from '../../api/api';

	export default {
		data() {
			return {
				filters: {
					username: ''
				},
				datalist: [],
				total: 0,
				pagesize:15,
				page: 1,
				listLoading: false,

				/////////////Form 表单
				editformtitle:'',//form编辑名称
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				formRules: {
					name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
					],
					username: [
						{ required: true, message: '请输入账号', trigger: 'blur' }
					]
				},
				role_options:[],
				company_options:[],
				//编辑界面数据
				editForm: {
					actionurl:'',
					sqlid:'',
					id: 0,
					username: '',cpcode:'',
					password:'',
					name:'',
					role:'',
					valid:'',type:''
				}
			}
		},
		methods: {
			clickClose:function(){},
			formatType: function (row) {
				if(row.type==1) return '系统用户:'+row.cpname;
				if(row.type==2) return '业务员:'+row.cpname;
				if(row.type==3) return '企业用户:'+row.cpname;
				return '未知';
			},
			formatValid: function (row, column) {
				return row.valid == 1 ? '有效' : row.valid == 0 ? '无效' : '未知';
			},
			formatRoles:function(row,column){
				var restr = '' ;
				this.role_options.forEach(function(d){
					if(row.role==d.value){
						restr = d.label;
						return ;
					}
				});
				return restr;
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getLists();
			},
			//获取权限选择框
			getRolesOptions(){
				let para = {
					actionurl:'default/getListAll',
					sqlid:'selectOptions.roles_options',
				};
				getListPage(para).then((res) => {
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.role_options = res.data.datas;
					}
				});
				
			},
			getCompanyOptions(){
				let para = {
					actionurl:'default/getListAll',
					sqlid:'h7iJaA2.dyshop_company.query',
				};
				getListPage(para).then((res) => {
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.company_options = res.data.datas;
					}
				});
				
			},
			//获取用户列表
			getLists() {
				let para = {
					page: this.page,
					pagesize:this.pagesize,
					username: this.filters.username,
					actionurl:'default/getList',
					sqlid:'roles.queryuser',
				};
				this.listLoading = true;
				//NProgress.start();
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					
					this.listLoading = false;
					//NProgress.done();
				});
			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { 
						id: row.id,
						actionurl:'default/del',
						sqlid:'roles.deluser'
					};
					delData(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
						this.getLists();
					});
				}).catch(() => {

				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '编辑';
				this.editForm = Object.assign({}, row);
				this.editForm.actionurl = 'default/save';//设置Sqlid
				this.editForm.sqlid = 'roles.uptuser';//设置Sqlid
			},
			//显示新增界面
			handleAdd: function () {
				this.editFormVisible = true;
				this.editformtitle = '新增';
				this.editForm = {
					actionurl:'default/save',
					sqlid:'roles.adduser',
					name: '',
					sex: -1,
					age: 0,
					birth: '',
					addr: ''
				};
			},
			//编辑保存
			editSubmit: function () {
				let para = Object.assign({}, this.editForm);
				util.saveFunction(this,para);
			}
		},
		mounted() {
			this.getCompanyOptions();
			this.getRolesOptions();
			this.getLists();
		}
	}
</script>



// WEBPACK FOOTER //
// Roleuser.vue?257dbb34